import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

/**
 * @param {{
 *    className?: string
 * }} props
 * @returns {React.Component}
 */
const PortletFooter = ({ className, ...props }) => {
  return <div {...props} className={clsx('zr-portlet__foot kt-portlet__foot', className)} />
}

PortletFooter.propTypes = {
  className: PropTypes.string
}

export default PortletFooter
